export class GlobalVariable {

    public static openModalStatus: boolean = false;
    public static openGlobalSearch: boolean = false;
    constructor() {
        
    }

}